import React from "react";

import CmsPreviewShell from "./CmsPreviewShell";
import mockData from "./mockData.json";

import type { CmsComponentProps, RankingMock } from "./types";

const formatPrice = (price: number) => price.toLocaleString("ko-KR") + "원";

// 랭킹 아이템 (mock/사용자 데이터). 캐러셀 레이아웃에서는 선택적 할인율을 노출한다.
type RankingItem = RankingMock & { discountRate?: number };

const RankingComponent: React.FC<CmsComponentProps> = ({ title, layout, items: userItems }) => {
  const items: RankingMock[] =
    userItems && userItems.length > 0
      ? userItems
          .filter((i) => i.is_active !== false)
          .map((i, idx) => ({
            id: idx,
            title: i.title,
            description: i.description ?? "",
            img: i.img ?? "",
            price: i.price ?? 0,
            rank: i.rank ?? idx + 1,
          }))
      : (mockData.ranking as RankingMock[]);

  const isCarousel = layout === "carousel";

  const renderCarouselItem = (item: RankingItem) => (
    <div key={item.id} className="cms-ranking__item">
      <div className="cms-ranking__media">
        <div className="cms-ranking__thumb">
          <img src={item.img} alt={item.title} />
        </div>
        <span className="cms-ranking__rank">{item.rank}</span>
      </div>
      <div className="cms-ranking__body">
        <h5 className="cms-ranking__title">{item.title}</h5>
        <p className="cms-ranking__desc">{item.description}</p>
        <div className="cms-ranking__price-row">
          {item.discountRate && <span className="cms-ranking__discount">{item.discountRate}%</span>}
          <span className="cms-ranking__price">{formatPrice(item.price)}</span>
        </div>
      </div>
    </div>
  );

  const renderDefaultItem = (item: RankingItem) => (
    <div key={item.id} className="cms-ranking__item">
      <div className="cms-ranking__media">
        <span className="cms-ranking__rank">{item.rank}</span>
        <div className="cms-ranking__thumb">
          <img src={item.img} alt={item.title} />
        </div>
      </div>
      <div className="cms-ranking__body">
        <h5 className="cms-ranking__title">{item.title}</h5>
        <p className="cms-ranking__desc">{item.description}</p>
        <span className="cms-ranking__price">{formatPrice(item.price)}</span>
      </div>
    </div>
  );

  return (
    <CmsPreviewShell title={title}>
      <div className={`cms-ranking cms-ranking--${layout}`}>
        {items.map(
          (item) => (isCarousel ? renderCarouselItem(item) : renderDefaultItem(item)),
          // <div key={item.id} className="cms-ranking__item">
          //   <span className="cms-ranking__rank">{item.rank}</span>
          //   <div className="cms-ranking__thumb">
          //     {item.img ? (
          //       <img src={item.img} alt={item.title} />
          //     ) : (
          //       <div className="cms-ranking__placeholder">이미지 없음</div>
          //     )}
          //   </div>
          //   <div className="cms-ranking__body">
          //     <h5 className="cms-ranking__title">{item.title}</h5>
          //     {item.description && <p className="cms-ranking__desc">{item.description}</p>}
          //     <span className="cms-ranking__price">{formatPrice(item.price)}</span>
          //   </div>
          // </div>
        )}
      </div>
    </CmsPreviewShell>
  );
};

export default RankingComponent;
